import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as e } from "../SvgIcon.js";
const m = (v) => /* @__PURE__ */ o(e, { ...v, children: /* @__PURE__ */ o("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4h7v5H2V4Zm9 0h7v5h-7V4Zm-2 7H2v5h7v-5Zm2 0h7v5h-7v-5Z" }) });
export {
  m as Grid
};
//# sourceMappingURL=Grid.js.map
